document.addEventListener('click', (event) => {
  document.querySelectorAll('.beauty-nav-group[open], .beauty-search[open], .beauty-mobile-nav[open]').forEach((details) => {
    if (!details.contains(event.target)) details.removeAttribute('open');
    if (details.classList.contains('beauty-mobile-nav') && event.target.closest('a')) details.removeAttribute('open');
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.beauty-header details[open]').forEach((details) => {
    details.removeAttribute('open');
    details.querySelector('summary')?.focus();
  });
});
document.querySelectorAll('a[href="#cbeauty-brands"]').forEach((link) => {
  link.addEventListener('click', () => document.querySelector('#cbeauty-brands details')?.setAttribute('open', ''));
});
